import { DownloadOption } from "@/entry/server/movie";
import { videoRepo } from "@/repo/video-repo";
import React, { useContext, useEffect, useState } from "react";
import { ConvertDownloadTypeToTitle, FormatSize } from "@/utils/movies_helper";
import ChevronDown from "@public/img/chevron-down.svg";
import PlayIcon from "@public/img/play-green.svg";
import { Link } from "react-router-dom";
import { AppContextType, WonmovContext } from "@/context/app-context";
import "@/styles/download-box.css";

type Episodes = {
    id: number;
    title: string;
    url: string;
}

type QualityDownloadGroup = {
    quality: string;
    quality_code: number;
    encoder: string;
    size: string;
    type: string;
    items: Episodes[];
}

type TypeDownloadGroup = {
    type: string;
    title: string;
    items: QualityDownloadGroup[];
}

type SeasonDownloadGroup = {
    season: number;
    title: string;
    items: TypeDownloadGroup[];
}

function formatEpisodeTitle(episode: number) {
    if (episode < 10) {
        return "قسمت 0" + episode;
    }
    return "قسمت " + episode;
}

export default function SeriesDlBox({ id }: { id: number }) {
    const [seasons, setSeasons] = useState<SeasonDownloadGroup[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(function () {
        getSeasons();
    }, [id]);

    async function getSeasons() {
        const response = await videoRepo.getDownloadOptions(id);
        if (response.status) {
            const groupedSeasons = GroupDownloadOptions({ downloadOptions: response.data! });
            setSeasons(groupedSeasons);
        }
        setIsLoading(false);
    }

    const panelClassName = isLoading
        ? "dlbox__panel dlbox__panel--loading shimmer"
        : "dlbox__panel";

    return (
        <div className="dlbox dlbox--series" id="download-box">
            <h2 className="movie-detail-section-title">باکس دانلود</h2>
            <div className={panelClassName}>
                {seasons.map(function (season, index) {
                    return (
                        <SeasonDownloadGroup key={"season-" + index} season={season} id={id} />
                    );
                })}
            </div>
        </div>
    )
}

function SeasonDownloadGroup({ season, id }: { season: SeasonDownloadGroup, id: number }) {
    const [isOpen, setIsOpen] = useState(false);

    function toggleSeason() {
        setIsOpen(!isOpen);
    }

    const bodyClassName = isOpen
        ? "dlbox-season__body dlbox-season__body--open"
        : "dlbox-season__body";

    const chevronClassName = isOpen
        ? "dlbox-season__chevron--open"
        : "";

    return (
        <div className="dlbox-season">
            <div className="dlbox-season__header" onClick={toggleSeason}>
                <button type="button" className="dlbox-season__toggle" onClick={toggleSeason}>
                    <img src={ChevronDown} alt="" className={chevronClassName} />
                </button>
                <div className="dlbox-season__title-wrap">
                    <p className="dlbox-season__title">{season.title}</p>
                </div>
            </div>

            <div className={bodyClassName}>
                {season.items.map(function (typeItem, typeIndex) {
                    return (
                        <div key={"type-" + typeIndex}>
                            <div className="dlbox__group-header">
                                <span className="dlbox__group-badge">{typeItem.title}</span>
                                <span className="dlbox__group-line" />
                            </div>
                            {typeItem.items.map(function (qualityItem, qualityIndex) {
                                return (
                                    <QualityDownloadGroup
                                        key={"quality-" + qualityIndex}
                                        quality={qualityItem}
                                        id={id}
                                        season={season.season}
                                    />
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

function QualityDownloadGroup({ quality, id, season }: { quality: QualityDownloadGroup, id: number, season: number }) {
    const [isOpen, setIsOpen] = useState(false);
    const { vipData, isLoggedIn } = useContext<AppContextType>(WonmovContext);

    const isVIPUser = isLoggedIn && vipData !== null && vipData.days_left > 0;

    if (!quality || !quality.items) {
        return null;
    }

    function toggleLinks() {
        setIsOpen(!isOpen);
    }

    function copyAllLinks() {
        const links = quality.items.map(function (item) {
            return item.url;
        }).join("\n");

        if (typeof document !== "undefined" && document.createElement) {
            const textarea = document.createElement("textarea");
            textarea.value = links;
            textarea.style.position = "fixed";
            textarea.style.left = "-9999px";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand("copy");
            } catch (e) {
                // ignore copy failures on legacy browsers
            }
            document.body.removeChild(textarea);
        }
    }

    const episodesClassName = isOpen
        ? "dlbox-quality__episodes dlbox-quality__episodes--open"
        : "dlbox-quality__episodes";

    return (
        <div className="dlbox-quality">
            <div className="dlbox-quality__header">
                <div className="dlbox-quality__meta">
                    <span className="dlbox__row-meta-label">تعداد قسمت: </span>
                    <span className="dlbox__row-meta-value">{quality.items.length}</span>
                </div>
                <div className="dlbox-quality__meta">
                    <span className="dlbox__row-meta-label">کیفیت: </span>
                    <span className="dlbox__row-meta-value dlbox__row-meta-value--quality">{quality.quality}</span>
                </div>
                <div className="dlbox-quality__meta">
                    <span className="dlbox__row-meta-label">انکودر: </span>
                    <span className="dlbox__row-meta-value">{quality.encoder}</span>
                </div>
                <div className="dlbox-quality__meta">
                    <span className="dlbox__row-meta-label">حجم: </span>
                    <span className="dlbox__row-meta-value">{quality.size}</span>
                </div>
                <div className="dlbox-quality__actions">
                    {isVIPUser ? (
                        <button type="button" className="dlbox__btn dlbox__btn--toggle" onClick={toggleLinks}>مشاهده لینک ها</button>
                    ) : isLoggedIn ? (
                        <Link to="/profile/subscription" target="_blank" className="dlbox__btn dlbox__btn--auth">تمدید اشتراک</Link>
                    ) : (
                        <Link to="/auth" className="dlbox__btn dlbox__btn--auth">ورود و ثبت نام</Link>
                    )}
                </div>
            </div>
            {isVIPUser ? (
                <div>
                    <div className="dlbox-quality__divider" />
                    <div className={episodesClassName}>
                        {quality.items.map(function (item, index) {
                            return (
                                <div key={"item-" + index} className="dlbox-episode">
                                    <div className="dlbox-episode__inner">
                                        <Link
                                            to={"/player/" + id + "?season=" + season + "&episode=" + item.id + "&quality=" + quality.quality + "&type=" + quality.type}
                                            className="dlbox-episode__play"
                                        >
                                            <img src={PlayIcon} alt="پخش" />
                                        </Link>
                                        <a href={item.url} target="_blank" className="dlbox-episode__link">{item.title}</a>
                                    </div>
                                </div>
                            );
                        })}
                        <div className="dlbox-episode__copy">
                            <button type="button" className="dlbox__btn dlbox__btn--outline" onClick={copyAllLinks}>کپی تمام لینک ها</button>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

function GroupDownloadOptions({ downloadOptions }: { downloadOptions: DownloadOption[] }): SeasonDownloadGroup[] {
    const seasons: SeasonDownloadGroup[] = [];
    downloadOptions.forEach(function (option) {
        const episode = {
            id: option.episode,
            title: formatEpisodeTitle(option.episode),
            url: option.url,
        }

        let season = seasons.find(function (s) {
            return s.season === option.season;
        });
        if (!season) {
            season = {
                season: option.season,
                title: "فصل " + option.season,
                items: []
            }
            seasons.push(season);
        }

        let type = season.items.find(function (t) {
            return t.type === option.type;
        });
        if (!type) {
            type = {
                type: option.type,
                title: ConvertDownloadTypeToTitle(option.type),
                items: []
            }
            season.items.push(type);
        }

        let encoder = option.encoder === "unknown" ? "نامشخص" : option.encoder;
        if (encoder.toLowerCase() === "film2media") {
            encoder = "Won Movie";
        }
        let quality = type.items.find(function (q) {
            return q.quality === option.quality && q.encoder === encoder;
        });
        if (!quality) {
            quality = {
                quality: option.quality,
                quality_code: parseInt(option.quality_code.split("p")[0], 10) || 0,
                encoder: encoder,
                size: FormatSize(option.size),
                type: option.type,
                items: [episode],
            };
            type.items.push(quality);
        } else {
            quality.items.push(episode);
        }
    });

    seasons.forEach(function (season) {
        season.items.forEach(function (item) {
            item.items.sort(compareQuality);
        });
    });

    return seasons;
}

function compareQuality(a: QualityDownloadGroup, b: QualityDownloadGroup) {
    if (a.quality_code > b.quality_code) return -1;
    if (a.quality_code < b.quality_code) return 1;
    return a.encoder.localeCompare(b.encoder, "fa");
}
